const students=[{name:"Joseph",class:"XI-B"},{name:"Stalin",class:"Our-B"},{name:"Roger",class:"X-A"},{name:"Akbar",class:"V-B"}]
export default students;